import script from "./ShippingAddresses.vue?vue&type=script&setup=true&lang=js"
export * from "./ShippingAddresses.vue?vue&type=script&setup=true&lang=js"

import "./ShippingAddresses.vue?vue&type=style&index=0&id=f54fcbd8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f54fcbd8"]])

export default __exports__